// @flow
import React, { Component } from "react";
import classNames from "classnames";
import Grid from "@material-ui/core/Grid";
import Avatar from "@material-ui/core/Avatar";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Chip from "@material-ui/core/Chip";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../../global/types/GeneralTypes";
import type {
  PanelStylesClassesType,
  TableStylesClassesType
} from "../../../global/styles/generalStyles";
import type { PersonType } from "../../types/PersonTypes";
import {
  panelStyles,
  tableStyles,
  padImg,
  formRightBtnBlock,
  redLabel
} from "../../../global/styles/generalStyles";
import PersonImage from "../../../../images/person_place.svg";
import { CancelButton, SubmitButton } from "imagus-components";

const styles = (theme: DictionaryType): DictionaryType => ({
  ...panelStyles(theme),
  ...tableStyles(theme),
  padImg,
  formRightBtnBlock,
  redLabel,
  rightMargin: {
    marginRight: "5px"
  },
  tableBlock: {
    maxHeight: "360px",
    overflowY: "auto"
  }
});

type BulkDeleteFormStatesType = {
  loading: boolean
};

type BulkDeleteFormClassesType = {
  ...PanelStylesClassesType,
  ...TableStylesClassesType,
  padImg: DictionaryType,
  formRightBtnBlock: DictionaryType,
  redLabel: DictionaryType,
  rightMargin: DictionaryType,
  tableBlock: DictionaryType
};

type BulkDeleteFormPropsType = {
  classes: BulkDeleteFormClassesType,
  checkedIds: Array<string>,
  people: Array<PersonType>,
  openSnackbar: Function,
  onClose: Function,
  deletePerson: Function
};

class BulkDeleteForm extends Component<
  BulkDeleteFormPropsType,
  BulkDeleteFormStatesType
> {
  constructor(props: BulkDeleteFormPropsType) {
    super(props);
    this.state = {
      loading: false
    };
  }

  submit = async (e: Event): * => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ loading: true });

    const checkedPeople = this.props.people.filter(
      (x: PersonType): Function => this.props.checkedIds.indexOf(x.uid) > -1
    );
    checkedPeople.map((person: PersonType): * => {
      this.props.deletePerson(person.uid);
    });
    this.submitDone();
  };

  submitDone = (): * => {
    this.setState({ loading: false });
    this.props.openSnackbar(true, 4);
    this.props.onClose();
  };

  render(): React$Element<*> {
    const classes = this.props.classes;
    const loading = this.state.loading;

    const checkedPeople = this.props.people.filter(
      (x: PersonType): Function => this.props.checkedIds.indexOf(x.uid) > -1
    );

    const people = checkedPeople.map((person: PersonType, i: number): * => (
      <TableRow key={"person" + i}>
        <TableCell className={classNames(classes.border, classes.compact)}>
          {person.name}
        </TableCell>
        <TableCell className={classNames(classes.border, classes.compact)}>
          <Avatar
            alt={person.face}
            className={classes.padImg}
            src={person.face ? person.face : PersonImage}
          />
        </TableCell>
        <TableCell className={classNames(classes.border, classes.compact)}>
          {person.tags &&
            person.tags.map((tag: string, j: number): * => (
              <Chip
                key={"chip" + j}
                label={tag}
                className={classes.rightMargin}
              />
            ))}
        </TableCell>
      </TableRow>
    ));

    return (
      <form
        onSubmit={(!loading && this.submit) || undefined}
        className={classes.appWrapper}
      >
        <div className={classes.appPanel}>
          <div className={classes.appPanelContent}>
            <Grid container spacing={8}>
              <Grid item xs={12} className={classes.tableBlock}>
                <Table className={classes.appTable}>
                  <TableHead>
                    <TableRow>
                      <TableCell className={classes.border} colSpan={3}>
                        Are you sure you want to{" "}
                        <span className={classes.redLabel}>delete</span> these
                        people?
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>{people}</TableBody>
                </Table>
              </Grid>
              <Grid item xs={12}>
                <div className={classes.formRightBtnBlock}>
                  <CancelButton onClick={this.props.onClose} />
                  <SubmitButton
                    loading={loading}
                    disabled={this.props.checkedIds.length === 0}
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </form>
    );
  }
}

export default withStyles(styles)(BulkDeleteForm);
